import { displayDurationExamService } from '../services'
import {useEffect, useState} from 'react'

interface Exam {
    name_exam: string;
    day_withdrawal: string;
    day_withdrawal_portal: string;
    display_duration_exam_categories: {
        category_name: string;
    };
}

interface DisplayDurationData {
    displayDurationExam: Exam[];
}

const useDisplayDurationExam = () => {
    const [data, setData] = useState<DisplayDurationData | null>(null);

    useEffect(() => {
        getDisplayDurationExams();
        //setData([])
    }, [])

    const getDisplayDurationExams = async () => {
        //setData(null)
        const resp = await displayDurationExamService.getDisplayDurationExams()
        setData(resp.data)
    }

    return {
        data,
        getDisplayDurationExams
    }
}

export { useDisplayDurationExam }